import { useMemo, useRef } from 'react'
import { idempotencyKey } from './format'
type Intent = { payload: string; key: string; scope: string }

export function useCommandKey(scope: string) {
  const intent = useRef<Intent | null>(null)
  return useMemo(() => {
    const storageKey = `admin-command:${scope}`
    function current() {
      if (intent.current?.scope === scope) return intent.current
      intent.current = null
      try {
        const stored: unknown = JSON.parse(sessionStorage.getItem(storageKey) || 'null')
        if (stored && typeof stored === 'object' && 'payload' in stored && 'key' in stored && typeof stored.payload === 'string' && typeof stored.key === 'string') intent.current = { payload: stored.payload, key: stored.key, scope }
      } catch { /* In-memory retries remain available when storage is unavailable. */ }
      return intent.current
    }
    function complete() {
      intent.current = null
      try { sessionStorage.removeItem(storageKey) } catch { /* The next in-memory intent still rotates. */ }
    }
    const keyFor = (payload: unknown): string => {
      const fingerprint = JSON.stringify(payload)
      if (current()?.payload !== fingerprint) {
        intent.current = { payload: fingerprint, key: idempotencyKey(scope.slice(0, 64)), scope }
        try { sessionStorage.setItem(storageKey, JSON.stringify(intent.current)) } catch { /* Keep the intent in memory. */ }
      }
      return intent.current!.key
    }
    return Object.assign(keyFor, { complete, currentKey: () => current()?.key, completeIf: (key: string) => { if (current()?.key === key) complete() } })
  }, [scope])
}
